import { render, staticRenderFns } from "./benefitsInfoCard.vue?vue&type=template&id=5aa46035"
import script from "./benefitsInfoCard.vue?vue&type=script&lang=js"
export * from "./benefitsInfoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports